var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "px-6 py-4 analytics-sticky bg-slate-300" }, [
      _c(
        "div",
        { staticClass: "flex items-center justify-between" },
        [
          _c("BlTextTitle3", { attrs: { text: "Acquisition Overview" } }),
          _vm._v(" "),
          _c("BlInputButton", {
            attrs: {
              type: "outlined",
              label: "Export to csv",
              loading: _vm.exportLoading
            },
            on: { clicked: _vm.onExportCSV }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "flex items-center gap-2 py-3" },
        [
          _vm.enableBranch
            ? _c(
                "div",
                { staticClass: "w-40" },
                [
                  _c("BlSelectBox", {
                    attrs: { type: "branch", options: _vm.branchOptions },
                    on: {
                      change: function($event) {
                        return _vm.onChangeBranch($event)
                      }
                    },
                    model: {
                      value: _vm.branchInput,
                      callback: function($$v) {
                        _vm.branchInput = $$v
                      },
                      expression: "branchInput"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c("BlInputSearch", {
            staticClass: "w-80",
            attrs: { input: _vm.searchInput },
            on: { changed: _vm.onInputSearch }
          }),
          _vm._v(" "),
          _c("BlInputFilter", {
            staticClass: "w-40",
            attrs: { input: _vm.filterInput },
            on: { changed: _vm.onChangeFilter }
          }),
          _vm._v(" "),
          _c("BlInputSelect", {
            attrs: { input: _vm.groupByInput },
            on: { changed: _vm.onChangeGroupBy }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "flex flex-col gap-2 pt-4" }, [
        _c(
          "div",
          [
            _c("BlTextBody2", { attrs: { text: "Showing results for " } }),
            _vm._v(" "),
            _c("BlTextSubtitle3", {
              attrs: { text: _vm.activeDateRange || "all time" }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "flex gap-5 pb-4 overflow-x-auto overflow-y-hidden scrollbar-lg"
          },
          [
            _c("div", { staticClass: "flex flex-col flex-grow gap-2" }, [
              _c(
                "div",
                {
                  staticClass:
                    "flex-grow flex-shrink-0 overflow-x-auto scrollbar-lg",
                  style: { height: "5.75rem" }
                },
                [
                  _vm.fetchGraphLoading
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "grid h-full rounded-lg place-content-center bg-pure-white"
                        },
                        [_c("div", { staticClass: "blum-loader-sm" })]
                      )
                    : !_vm.graphData
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "grid h-full rounded-lg place-content-center bg-pure-white"
                        },
                        [
                          _c("BlTextBody2", {
                            attrs: { text: "Data not found." }
                          })
                        ],
                        1
                      )
                    : _c(
                        "div",
                        { staticClass: "flex gap-2" },
                        _vm._l(_vm.overviewData, function(item, idx) {
                          return _c(
                            "div",
                            {
                              key: item.label,
                              staticClass:
                                "flex flex-col justify-center flex-shrink-0 gap-1 px-2 transition-all duration-300 border rounded-lg cursor-pointer bg-pure-white hover:bg-slate-200",
                              class: [
                                item.selected
                                  ? "border-slate-500 shadow"
                                  : "border-transparent"
                              ],
                              style: {
                                height: "5rem",
                                width:
                                  "calc((100% - " +
                                  (_vm.overviewData.length - 1) * 0.5 +
                                  "rem) / 6)"
                              },
                              attrs: { title: item.label },
                              on: {
                                click: function($event) {
                                  _vm.overviewData[
                                    idx
                                  ].selected = !item.selected
                                }
                              }
                            },
                            [
                              item.is_admitted
                                ? _c("BlTextTitle3", {
                                    staticClass: "self-center",
                                    class: [
                                      item.selected
                                        ? "text-lime-600"
                                        : "text-lime-400"
                                    ],
                                    attrs: { text: item.value }
                                  })
                                : item.is_pending
                                ? _c("BlTextTitle3", {
                                    staticClass: "self-center text-tulip-600",
                                    class: [item.selected ? "" : "opacity-50"],
                                    attrs: { text: item.value }
                                  })
                                : item.is_discontinued
                                ? _c("BlTextTitle3", {
                                    staticClass: "self-center",
                                    class: [
                                      item.selected
                                        ? "text-rose-700"
                                        : "text-rose-400"
                                    ],
                                    attrs: { text: item.value }
                                  })
                                : _c("BlTextTitle3", {
                                    staticClass: "self-center",
                                    class: [
                                      item.selected
                                        ? "text-slate-900"
                                        : "text-slate-600"
                                    ],
                                    attrs: { text: item.value }
                                  }),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "text-center truncate" },
                                [
                                  _c("BlTextBody2", {
                                    staticClass: "truncate",
                                    class: { "opacity-50": !item.selected },
                                    attrs: { text: item.label }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        }),
                        0
                      )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "flex-grow flex-shrink-0 rounded-3xl bg-pure-white",
                  style: { height: "31rem", width: "auto" }
                },
                [
                  _vm.fetchGraphLoading
                    ? _c(
                        "div",
                        { staticClass: "grid h-full place-content-center" },
                        [_c("div", { staticClass: "blum-loader" })]
                      )
                    : !_vm.graphData
                    ? _c(
                        "div",
                        { staticClass: "grid h-full place-content-center" },
                        [
                          _c("BlTextBody2", {
                            attrs: { text: "Data not found." }
                          })
                        ],
                        1
                      )
                    : _c(
                        "div",
                        { staticClass: "flex flex-col gap-3 px-6 py-6" },
                        [
                          _c("BlTextSubtitle2", {
                            staticClass: "text-slate-700",
                            attrs: { text: "Prospect movement across stages" }
                          }),
                          _vm._v(" "),
                          _c("BarChart", {
                            attrs: {
                              labels: _vm.barChartData.labels,
                              datasets: _vm.barChartData.datasets,
                              stacked: "",
                              height: "23.5rem",
                              width:
                                "calc((100vw - 15rem - 3.5rem) - 3rem - 1.25rem - 13rem)"
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "flex items-center gap-5",
                              style: {
                                width:
                                  "calc((100vw - 15rem - 3.5rem) - 3rem - 1.25rem - 13rem)"
                              }
                            },
                            [
                              _vm._l(
                                _vm.barChartData.legends.slice(0, 6),
                                function(legend) {
                                  return _c(
                                    "div",
                                    {
                                      key: legend.label,
                                      staticClass:
                                        "flex items-center gap-1 truncate",
                                      attrs: { title: legend.label }
                                    },
                                    [
                                      _c("div", {
                                        staticClass:
                                          "h-3.5 w-3.5 flex-shrink-0 rounded-full",
                                        style: { backgroundColor: legend.color }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "truncate" },
                                        [
                                          _c("BlTextBody2", {
                                            attrs: { text: legend.label }
                                          })
                                        ],
                                        1
                                      )
                                    ]
                                  )
                                }
                              ),
                              _vm._v(" "),
                              _vm.barChartData.legends.slice(6).length
                                ? _c("div", { staticClass: "relative" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "flex items-center justify-center cursor-pointer",
                                        on: {
                                          click: function($event) {
                                            _vm.moreLegend = !_vm.moreLegend
                                          }
                                        }
                                      },
                                      [
                                        _c("BlBubbleCount", {
                                          staticClass:
                                            "h-7 hover:bg-light-purple-100",
                                          attrs: {
                                            count:
                                              "+ " +
                                              _vm.barChartData.legends.slice(6)
                                                .length
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _vm.moreLegend
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "absolute bottom-0 right-0 z-10 flex flex-col gap-1 p-1 mb-10 truncate border rounded min-w-32 bg-pure-white border-grey-200",
                                            style: { zIndex: 1 }
                                          },
                                          _vm._l(
                                            _vm.barChartData.legends
                                              .slice(6)
                                              .reverse(),
                                            function(i, idx) {
                                              return _c(
                                                "div",
                                                {
                                                  key: idx,
                                                  staticClass:
                                                    "flex items-center gap-1 px-4 py-2 truncate rounded max-w-64",
                                                  attrs: { title: i.label }
                                                },
                                                [
                                                  _c("div", {
                                                    staticClass:
                                                      "h-3.5 w-3.5 flex-shrink-0 rounded-full",
                                                    style: {
                                                      backgroundColor: i.color
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    { staticClass: "truncate" },
                                                    [
                                                      _c("BlTextBody2", {
                                                        attrs: { text: i.label }
                                                      })
                                                    ],
                                                    1
                                                  )
                                                ]
                                              )
                                            }
                                          ),
                                          0
                                        )
                                      : _vm._e()
                                  ])
                                : _vm._e()
                            ],
                            2
                          )
                        ],
                        1
                      )
                ]
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "flex flex-col gap-5", style: { width: "13rem" } },
              [
                _c(
                  "div",
                  {
                    staticClass: "flex-shrink-0 rounded-3xl bg-pure-white",
                    style: { height: "18rem" }
                  },
                  [
                    _vm.fetchGraphLoading
                      ? _c(
                          "div",
                          { staticClass: "grid h-full place-content-center" },
                          [_c("div", { staticClass: "blum-loader" })]
                        )
                      : !_vm.graphData
                      ? _c(
                          "div",
                          { staticClass: "grid h-full place-content-center" },
                          [
                            _c("BlTextBody2", {
                              attrs: { text: "Data not found." }
                            })
                          ],
                          1
                        )
                      : _c(
                          "div",
                          { staticClass: "flex flex-col gap-3 px-6 py-6" },
                          [
                            _c(
                              "div",
                              { staticClass: "h-10" },
                              [
                                _c("BlTextSubtitle2", {
                                  staticClass: "text-slate-700",
                                  attrs: { text: "Referral" }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("PieChart", {
                              attrs: {
                                labels: _vm.pieChartDataReferral.labels,
                                colors: _vm.pieChartDataReferral.colors,
                                data: _vm.pieChartDataReferral.data,
                                height: "6.25rem"
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "flex flex-col gap-3 h-15" },
                              _vm._l(_vm.pieChartLegendsReferral, function(
                                legend
                              ) {
                                return _c(
                                  "div",
                                  {
                                    key: legend.label,
                                    staticClass:
                                      "flex items-center justify-between gap-2"
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "flex items-center gap-1 truncate",
                                        attrs: { title: legend.label }
                                      },
                                      [
                                        _c("div", {
                                          staticClass:
                                            "h-3.5 w-3.5 flex-shrink-0 rounded-full",
                                          style: {
                                            backgroundColor: legend.color
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c("BlTextBody2", {
                                          staticClass: "truncate",
                                          attrs: { text: legend.label }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      [
                                        _c("BlTextSubtitle3", {
                                          staticClass: "text-slate-800",
                                          attrs: { text: legend.value }
                                        })
                                      ],
                                      1
                                    )
                                  ]
                                )
                              }),
                              0
                            ),
                            _vm._v(" "),
                            _vm.pieChartPageCountReferral > 1
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "flex items-center justify-center"
                                  },
                                  _vm._l(
                                    _vm.pieChartPageCountReferral,
                                    function(n) {
                                      return _c(
                                        "div",
                                        {
                                          key: n,
                                          staticClass: "p-1 cursor-pointer",
                                          on: {
                                            click: function($event) {
                                              _vm.pieChartPageReferral = n
                                            }
                                          }
                                        },
                                        [
                                          _c("div", {
                                            staticClass:
                                              "h-2.5 w-2.5 flex-shrink-0 rounded-full hover:bg-slate-700 transition-all duration-300",
                                            class: [
                                              _vm.pieChartPageReferral === n
                                                ? "bg-slate-700"
                                                : "bg-slate-500"
                                            ]
                                          })
                                        ]
                                      )
                                    }
                                  ),
                                  0
                                )
                              : _vm._e()
                          ],
                          1
                        )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "flex-shrink-0 rounded-3xl bg-pure-white",
                    style: { height: "18rem" }
                  },
                  [
                    _vm.fetchGraphLoading
                      ? _c(
                          "div",
                          { staticClass: "grid h-full place-content-center" },
                          [_c("div", { staticClass: "blum-loader" })]
                        )
                      : !_vm.graphData
                      ? _c(
                          "div",
                          { staticClass: "grid h-full place-content-center" },
                          [
                            _c("BlTextBody2", {
                              attrs: { text: "Data not found." }
                            })
                          ],
                          1
                        )
                      : _c(
                          "div",
                          { staticClass: "flex flex-col gap-3 px-6 py-6" },
                          [
                            _c(
                              "div",
                              { staticClass: "h-10" },
                              [
                                _c("BlTextSubtitle2", {
                                  staticClass: "text-slate-700",
                                  attrs: { text: "Discontinued reason" }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("PieChart", {
                              attrs: {
                                labels: _vm.pieChartDataReason.labels,
                                colors: _vm.pieChartDataReason.colors,
                                data: _vm.pieChartDataReason.data,
                                height: "6.25rem"
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "flex flex-col gap-3 h-15" },
                              _vm._l(_vm.pieChartLegendsReason, function(
                                legend
                              ) {
                                return _c(
                                  "div",
                                  {
                                    key: legend.label,
                                    staticClass:
                                      "flex items-center justify-between gap-2"
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "flex items-center gap-1 truncate",
                                        attrs: { title: legend.label }
                                      },
                                      [
                                        _c("div", {
                                          staticClass:
                                            "h-3.5 w-3.5 flex-shrink-0 rounded-full",
                                          style: {
                                            backgroundColor: legend.color
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c("BlTextBody2", {
                                          staticClass: "truncate",
                                          attrs: { text: legend.label }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      [
                                        _c("BlTextSubtitle3", {
                                          staticClass: "text-slate-800",
                                          attrs: { text: legend.value }
                                        })
                                      ],
                                      1
                                    )
                                  ]
                                )
                              }),
                              0
                            ),
                            _vm._v(" "),
                            _vm.pieChartPageCountReason > 1
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "flex items-center justify-center"
                                  },
                                  _vm._l(_vm.pieChartPageCountReason, function(
                                    n
                                  ) {
                                    return _c(
                                      "div",
                                      {
                                        key: n,
                                        staticClass: "p-1 cursor-pointer",
                                        on: {
                                          click: function($event) {
                                            _vm.pieChartPageReason = n
                                          }
                                        }
                                      },
                                      [
                                        _c("div", {
                                          staticClass:
                                            "h-2.5 w-2.5 flex-shrink-0 rounded-full hover:bg-slate-700 transition-all duration-300",
                                          class: [
                                            _vm.pieChartPageReason === n
                                              ? "bg-slate-700"
                                              : "bg-slate-500"
                                          ]
                                        })
                                      ]
                                    )
                                  }),
                                  0
                                )
                              : _vm._e()
                          ],
                          1
                        )
                  ]
                )
              ]
            )
          ]
        )
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      [
        _c(
          "div",
          {
            staticClass:
              "z-10 flex items-center justify-between px-6 py-4 analytics-sticky top-18 bg-slate-100"
          },
          [
            _c(
              "div",
              [
                _c("BlTextBody2", {
                  attrs: {
                    text: "Showing all " + _vm.tableCount + " prospect(s)"
                  }
                }),
                _vm._v(" "),
                _vm.currentStageFilter.length
                  ? _c("BlTextBody2", {
                      attrs: {
                        text:
                          "based on the filters: date range (" +
                          (_vm.dateFilter || "all time") +
                          ") and " +
                          _vm.currentStageFilter.length +
                          " stage(s)."
                      }
                    })
                  : _vm.dateFilter
                  ? _c("BlTextBody2", {
                      attrs: {
                        text:
                          "who moved between stages within the date range " +
                          _vm.dateFilter +
                          "."
                      }
                    })
                  : _c("BlTextBody2", {
                      attrs: { text: "who moved between stages for all time." }
                    })
              ],
              1
            ),
            _vm._v(" "),
            _c("BlSort", {
              attrs: {
                options: _vm.sortOptions,
                defaultValue: _vm.defaultSort,
                dropDirection: "left"
              },
              on: { change: _vm.onChangeSort },
              model: {
                value: _vm.sortInput,
                callback: function($$v) {
                  _vm.sortInput = $$v
                },
                expression: "sortInput"
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _vm.fetchTableLoading
          ? _c(
              "div",
              {
                staticClass: "grid h-64 analytics-sticky place-content-center"
              },
              [_c("div", { staticClass: "blum-loader" })]
            )
          : _c("TableAcquisitionOverview", {
              attrs: { tableData: _vm.tableData }
            }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "px-6 pt-4 analytics-sticky pb-36" },
          [
            _vm.tableCount > 25
              ? _c("BlInputPagination", {
                  attrs: {
                    page: _vm.page,
                    perPage: _vm.perPage,
                    total: _vm.tableCount
                  },
                  on: {
                    changed: _vm.changePage,
                    "changed-per-page": _vm.changePerPage
                  }
                })
              : _vm._e()
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2ba19cc6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2ba19cc6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/analytics/AcquisitionOverview.vue
// module id = null
// module chunks = 